import { useState, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import fetchData from "./APIBaseMethod";
import dateUtils from "../helper/dateFormater";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useCaseHistoryAPIDetails = () => {
  const [loading, setLoading] = useState(false);
  const isSubmitting = useRef(false);

  const getCaseHistoryList = async (caseid) => {
    const resposne = await fetchData(`/api/v1/case-history/${caseid}/list`);
    if (!resposne) return null;
    return resposne;
  };

  const getCaseHistoryData = async (id, onSuccess, onError) => {
    try {
      const response = await fetchData(`/api/v1/case-history/${id}/get`);
      response ? onSuccess(response) : onError("Failed to process request.");
    } catch (ex) {
      onError(ex);
    }
  };
  const addNewCaseHistory = async (id, historyData, onSuccess, onError) => {
    try {
      const formattedData = {
        ...historyData,
        hearing_date: dateUtils.formatDateForInput(historyData.hearing_date),
      };

      const url = id
        ? `/api/v1/case-history/${id}/update`
        : "/api/v1/case-history/create";

      const token = Cookies.get("auth_token");
      const response = await axios({
        method: id ? "put" : "post",
        url: `${API_BASE_URL}${url}`,
        data: formattedData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      response.data.status === "Success"
        ? onSuccess(response.data)
        : onError("Failed to process request.");
    } catch (error) {
      const errorMessage =
        error.response?.status === 400 && error.response.data?.errors?.fileNo
          ? "File number already taken."
          : "An error occurred while processing the case.";
      onError(errorMessage);
    } finally {
      isSubmitting.current = false;
      setLoading(false);
    }
  };

  const deleteCaseHistoryData = async (id) => {
    try {
      const token = Cookies.get("auth_token");
      const response = await axios.delete(
        `${API_BASE_URL}/api/v1/case-history/${id}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.status === "Success";
    } catch (error) {
      console.error(`Error deleting ${id}:`, error);
      return false;
    }
  };

  return {
    getCaseHistoryList,
    loading,
    getCaseHistoryData,
    addNewCaseHistory,
    deleteCaseHistoryData,
  };
};

export default useCaseHistoryAPIDetails;
